<template>
    <div class="h-100" style="padding-bottom: 14px;">
        <div style="height:55px;border-bottom: 1px solid #1e1e1e;padding:8px 0px;" class="filter-fields-in-logs w-100">
            
            <filters-top-bar 
            v-bind="currentDownloadReportProperties"
            @changeSelectedReportComponent="changeSelectedReportComponent"
            >
            </filters-top-bar>

            <button-top-bar v-if="getLoggedInUserInfo().user_type == 'SystemAdmin'" title="Generate Report"
             v-on:click.native="downloadassetsReportData()">
            </button-top-bar>
        </div>
        <div class="ingest-report-div" style="margin-top: 16px;">
            <table  v-if="assetsReportData && assetsReportData.length> 0" class="table table-with-border table-scroll small-first-col"  style="background: transparent;">
                <thead style="color: #eee">
                    <tr>
                        <th style="width: 40%;padding-inline-start: 0px !important;" class="text-left">Slug Name</th>
                        <!-- <th style="width: 10%;padding-inline-start: 0px !important;" class="text-left">Type</th> -->
                        <th style="width: 20%" class="text-center">Created datetime</th>
                        <th style="width: 20%" class="text-center">Modified datetime</th>
                        <th style="width: 10%;" class="text-center">Size</th>
                        <th style="width: 10%;" class="text-center">Duration</th>
                        <!-- <th style="width: 24%;padding-inline-start: 8px !important;" class="text-left">Location</th> -->
                    </tr>
                </thead>
                <tbody>
                    <template  v-for="assetLog in assetsReportData"> 
                        <tr    
                            :key="assetLog._id"
                            class="ccomm-logs-row" :class="{activeclass: activeIndex === assetLog._id}">

                            <td class="text-left" style="position:relative;padding-inline-end: 10px !important;width:50%">
                                <span v-if="Object.keys(assetLog).includes('slug_name') && assetLog.slug_name.length > 0" style="cursor: text;pointer-events: all;user-select: text;word-break: break-word;" :title="assetLog.slug_name">{{ assetLog.slug_name }}
                                    <span v-if="!descriptionVisibilityArr.includes(assetLog._id) && assetLog.metadata && assetLog.metadata.description && assetLog.metadata.description.length > 200" class="secondary-dull-the-text description-alignment">&nbsp;-&nbsp;{{assetLog.metadata.description.substring(0,200)}}...<span @click.stop.prevent="seeMoreDescription(assetLog._id)"><b style="color:#bdbdbd">see more</b></span></span>
                                    <span v-else-if="assetLog.metadata && assetLog.metadata.description && assetLog.metadata.description" class="secondary-dull-the-text description-alignment">&nbsp;-&nbsp;{{assetLog.metadata.description}}</span>
                                </span>
                                <span v-else class="validationmessage">No Data found</span>
                                <div class="file-extra-info">
                                    <div v-if="assetLog.reference_id && barcodeInfoFromStartup.enable_reference_id_workflow" style="color:#9a7d7d">{{barcodeInfoFromStartup.alias &&  barcodeInfoFromStartup.alias.alias_name?barcodeInfoFromStartup.alias.alias_name:"Reference ID"}}:{{assetLog.reference_id}}</div>
                                    <div v-if="assetLog.parent_path" class="d-flex" style="position: relative;inset-inline-start:0px;display:flex;font-size:12px;flex-wrap:wrap">
                                        <div v-for="(path,index) in assetLog.parent_path" :key="path.id" class="dull-the-text comm-lengthy-value-styles">/{{modifyTextFormat(path.value)}}{{index == assetLog.parent_path.length -1?'':','}}&nbsp;&nbsp;</div>
                                    </div>
                                    <template v-if="assetLog.metadata && assetLog.metadata.tag_values">
                                        <div  class="d-flex" style="flex-wrap:wrap;margin:5px 0px">
                                            <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;" v-for="tag in assetLog.metadata.tag_values" :key="tag">
                                            <div style="display: flex;align-items: center;width: 12px;">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3a0a0" class="bi bi-tag-fill" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                                                </svg>
                                            </div>
                                            <div>{{tag}}</div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </td>
<!-- 
                            <td class="text-left" style="position:relative;">
                                <span v-if="Object.keys(assetLog).includes('asset_type') && assetLog.asset_type.length > 0" :title="assetLog.asset_type" class="text-ellipsis">{{ assetLog.asset_type }}</span>
                                <span v-else class="validationmessage">No Data found</span>
                            </td> -->

                            <td class="text-center" style="width:20%">
                                <!-- <span v-if="Object.keys(assetLog).includes('created_datetime') && assetLog.created_datetime.length > 0">{{formatedDate(assetLog.created_datetime)}}</span> -->
                                <span v-if="Object.keys(assetLog).includes('asset_created_datetime') && assetLog.asset_created_datetime.length > 0" :title="getDateAndTimeInConfiguredFormat(assetLog.asset_created_datetime)">{{checkIsTodayoryesterdayDate(assetLog.asset_created_datetime)?getDateAndTimeInConfiguredFormat(assetLog.asset_created_datetime, true) : getDateAndTimeInConfiguredFormat(assetLog.asset_created_datetime)}}</span>
                                <span v-else class="validationmessage">No Data found</span>
                            </td>

                            <td class="text-center" style="width:20%">
                                <!-- <span v-if="Object.keys(assetLog).includes('created_datetime') && assetLog.created_datetime.length > 0">{{formatedDate(assetLog.created_datetime)}}</span> -->
                                <span v-if="Object.keys(assetLog).includes('asset_modified_datetime') && assetLog.asset_modified_datetime.length > 0" :title="getDateAndTimeInConfiguredFormat(assetLog.asset_modified_datetime)">{{checkIsTodayoryesterdayDate(assetLog.asset_modified_datetime)?getDateAndTimeInConfiguredFormat(assetLog.asset_modified_datetime, true) : getDateAndTimeInConfiguredFormat(assetLog.asset_modified_datetime)}}</span>
                                <span v-else class="validationmessage">No Data found</span>
                            </td>

                            <td class="text-center" style="width:15%">
                                <span v-if="assetLog.size">{{getConvertedFileSize(assetLog.size)}}</span>
                                <span v-else class="validationmessage">No Data found</span>
                            </td>

                            <td class="text-center" style="width:15%">
                                <span v-if="assetLog.duration">{{getHumanReadableDuration(assetLog.duration)}}</span>
                                <span v-else> - </span>
                            </td>

                            <!-- <td style="position:relative;padding-inline-start: 9px !important;">
                                <span v-if="Object.keys(assetLog).includes('data') && assetLog.data.parent_path.length > 0" :title="assetLog.data.parent_path" style="word-break: break-all;">{{assetLog.data.parent_path}}</span>
                                <span v-else class="validationmessage">No Data found</span>
                            </td> -->

                        </tr>
                    </template>
                </tbody>
            </table> 
            <div v-else class="dull-the-text" style="display: flex;justify-content: center;align-items: center;font-size: 20px;height:100%">
                    No Data Found
            </div> 
        </div>  
        <div>
            <pagination
                v-model="page"
                :records="totalAssets"
                :per-page="perPage"
                @paginate="paginate"
                :options="options"
                style="margin-top:10px"
            />    
        </div>         
    </div>
</template>   

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import Utils from "../../components.utils.js";  
    import buttonsTopbar from "./headerbar.vue";
    import Pagination from "vue-pagination-2";
    // import DatePicker from "vue2-datepicker";
    // import "vue2-datepicker/index.css";
    // import Multiselect from 'vue-multiselect';
    import FiltersTopbar from "./filtersBar.vue";
    import {NotifierConstants} from "../../components.constants.js";
    export default {
        data(){
                return{
                    page: 1,
                    totalPages: -1,
                    totalAssets: -1,
                    perPage: -1,
                    assetsReportData:[],
                    ingestUserMap:[],
                    userNameIdMap:{},
                    time1:null,
                    selectedUserInfo:{},
                    selectedUserGroupInfo:{},
                    filterBy:{},
                    userListFromAutocomplete:[],
                    userGroupListFromAutocomplete:[],
                    searchByUser:"",
                    showUserFilter:false,
                    showUserGroupFilter:false,
                    searchByGroup:"",
                    fileNameFilter:"",
                    // filterByAction:{
                    //     state:"All",
                    //     job_name:"All"
                    // },
                    options:{chunk:5},
                    selectedJobName:"All",
                    searchKey :"",

                    payloadParams : {},
                    activeIndex:null,
                    descriptionVisibilityArr:[],
                    subText:true,
                } 
        },  
        components:{
            // 'k-progress': KProgress,
            pagination: Pagination,
            "button-top-bar":buttonsTopbar,
            "filters-top-bar":FiltersTopbar,
        },
        methods:{
            seeMoreDescription(id){
                if(!this.descriptionVisibilityArr.includes(id)){
                    this.descriptionVisibilityArr.push(id)
                }
            },
            modifyTextFormat(text){
                if(text){
                    let temp = text.split("catalog://0/")[1];
                    if(temp){
                        temp = temp.replace("/","/")
                        return temp;
                    }
                }
            },
    
            changeSelectedReportComponent(filtersdata){
                if(filtersdata.from_date){
                    this.payloadParams['created_on'] = {'type':'range','from_value':filtersdata.from_date.split("T")[0],'to_value':filtersdata.to_date.split("T")[0]}
                }else{
                    delete this.payloadParams.created_on;
                }
                if(filtersdata.type){
                    this.payloadParams['type'] = filtersdata.type
                }
                if(filtersdata.file_name && filtersdata.file_name.length > 0){
                    this.payloadParams['keyword'] = filtersdata.file_name;
                }else{
                    delete this.payloadParams.keyword;
                }
                this.refreshAssetsReport(false);
            },
            refreshAssetsReport(isPageClick = false) {
                // this.showUserFilter = false
                // this.showUserGroupFilter = false
                let payload = {}
                // let paramsInfo = {}
                if(isPageClick){
                     this.payloadParams.page = this.page
                }else{
                    this.page = 1;
                    delete this.payloadParams.page;
                }
                
                // if(typeof this.selectedUserInfo != "undefined"){
                //     let userIdList = [];
                //     userIdList.push(this.selectedUserInfo._id);
                //     paramsInfo.user_id = this.userIdList
                // }
                // if(typeof this.selectedUserGroupInfo != "undefined"){
                //     paramsInfo.group_id = this.selectedUserGroupInfo._id
                // }
                // if(typeof this.time1 != "undefined" &&
                // this.time1 != null && this.time1.length == 2 && this.time1[0] != null){
                //     paramsInfo.from_date = this.time1[0]+"T00:00:00"
                //     paramsInfo.to_date = this.time1[1]+"T00:00:00"
                // }
                // if(typeof this.fileNameFilter != "undefined" && this.fileNameFilter.trim().length > 0){
                //     paramsInfo["file_name"] = this.fileNameFilter
                //     paramsInfo.filter=JSON.stringify(["file_name"])
                // }

                // if(typeof this.filterByAction != "undefined" && (this.filterByAction.job_name.trim() <= 0 || this.filterByAction.job_name.trim() != "All")){
                //     paramsInfo["action"] = this.filterByAction.job_name;
                // }
                // payload.params = paramsInfo
                if(!this.payloadParams.type){
                    this.payloadParams['type'] = 'file';
                }
                this.payloadParams['view_type'] = 'list';
                this.payloadParams['sort_by'] = 'added_datetime';
                this.payloadParams['sort_order'] = -1;
                // this.payloadParams['type'] = 'file';
                this.payloadParams['state'] = 'ready';
                if(this.payloadParams.keyword && this.payloadParams.keyword.length > 0){
                    this.payloadParams['search_in'] = JSON.stringify(['slug_name']);
                }
                this.payloadParams['catalog_id'] = this.getRootCategoryDetails()._id;
                payload.params = this.payloadParams;
                payload.isPrivExists = this.isPrivilegeExists('reports');
                this.getAssetReportsData(payload).then((data) => {
                    this.totalPages = data["page_count"];
                    // this.page = data["page"];
                    this.totalAssets = data["total_assets"];
                    this.perPage = data["assets_per_page"];
                    this.assetsReportData = data.assets;
                    // this.ingestUserMap = data.user_map;
                    // this.userListFromAutocomplete = []
                    // this.userGroupListFromAutocomplete = []
                }); 
            },
            
            isPrivilegeExists(privilegeName){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(), privilegeName);
            },

            downloadassetsReportData() {
                // let filePath = url;
                let payload = {};
                this.payloadParams['from_reports'] = true;
                if(!this.payloadParams.type){
                    this.payloadParams['type'] = 'file';
                }
                payload.params =this.payloadParams;
                this.payloadParams['limit'] = this.totalAssets;
                this.$toast.info("You will be notified once the report is ready to download");
                this.downloadAssetsReportFromServer(payload).then(() => {
                    console.log("Downloading report")
                })
                .catch(console.error);
            },

            getHumanReadableDuration(duration){
                return Utils.getDurationInSeconds(duration)
            },

            // getConvertedFileSize(size){
            //     return Utils.getConvertedFileSize(size);
            // },  

            // ...mapActions("ingestReports", ["getStorageReportFromServer"]),
            getusersOnKeyup(option){
                this.showUserFilter = true
                this.showUserGroupFilter = false
                let payload = {}
                // if(typeof(option) != "undefined" && option.trim().length > 0){
                if(typeof(option) != "undefined" && option.length > 0){  
                    payload.params = {username:option}
                    this.getUsersAutoComplitionFromServerIngest(payload).then((data) => {
                        this.userGroupListFromAutocomplete = [];
                        this.userListFromAutocomplete = data["users"];
                    });
                }else if(option.length==0){
                    // this.updateUsersList(false);
                    // this.filterBy.user_id = "";
                    // this.updateJobsListFromServer(false,true, option);
                    // this.userListFromAutocomplete = this.usersList;
                    // delete this.selectedUserInfo._id;
                    // this.refreshAuditLogs(false)
                    this.getAllUsersFromServerIngest(payload).then((data) => {
                        this.userListFromAutocomplete = data.users;
                    });
                }
            },

            hideUsersDropdown(){
                if(this.userListFromAutocomplete.length > 0 && this.searchByUser.length==0){
                    this.userListFromAutocomplete = [];
                }
            },
            selectionLabelCallback(option){
                return `${option.username}`
            },
            updateUsersFilter(option){
                this.selectedUserInfo["_id"] = option._id;
                this.searchKey = option.username;
                this.refreshAuditLogs(false);
            },
            getUserGroupsOnKeyup(){
                this.showUserGroupFilter = true
                this.showUserFilter = false
                let payload = {};
                payload.params = {user_id: this.selectedUserID};
                this.getAllUserGroupsFromServer(payload).then((data)=>{
                    this.userGroupListFromAutocomplete = data.user_groups;
                });
            },

            getConvertedFileSize(size){
                return Utils.getConvertedFileSize(size);
            }, 

            formatedDate(date){
                return Utils.getDateTimeFormat(date);
            },
            getUserNameFromId(userId){
                let username = ""
                if(this.ingestUserMap.length > 0){
                    let usermap = this.ingestUserMap.filter((usersMap)=>(usersMap.user_id == userId))
                    if(usermap != undefined &&  typeof usermap != "undefined" && usermap[0]!= undefined){
                      
                        username = usermap[0].username
                    }
                }
                return username
            },

            paginate() {
                // this.page = page;
                this.refreshAssetsReport(true);
            },
            handleIngestNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    this.refreshAssetsReport(false)
                }
            },
            registerforWebsocketNotifications(){
                this.addWSEventListener({
                    eventname:[NotifierConstants.fileCreatedNotification],
                    callback:this.handleIngestNotification,
                    parent: "IngestReports"})
            },
            unRegisterforWebsocketNotifications(){
                this.removeWSEventListener({
                    eventname:[NotifierConstants.fileCreatedNotification],
                    callback:this.handleIngestNotification,
                    parent: "IngestReports"})
            },

            ...mapActions("assets", ["getAssetReportsData", "downloadAssetsReportFromServer"]),
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapGetters("users",["getLoggedInUser","getLoggedInUserInfo","getLoggedInUserId","getLoggedInUserPrivilege"]),
            ...mapGetters("categories", ["getSelectedCategoryInCategoryBrowse","getRootCategoryDetails"]),
        },
        beforeDestroy(){
            this.unRegisterforWebsocketNotifications()
        },
        created(){
            // this.refreshAssetsReports(false);
            // this.searchByUser = this.getLoggedInUser()
            // this.selectedUserInfo._id= this.getLoggedInUserId();
            // this.showUserFilter = false;
            // let loggedInUserIdList = [];
            // loggedInUserIdList.push(this.selectedUserInfo._id);
            // this.payloadParams["user_id"] = JSON.stringify(loggedInUserIdList);
            this.refreshAssetsReport(false);
            this.registerforWebsocketNotifications()
        },
        computed: {
            currentDownloadReportProperties() {
                return { reportContext : "assets"};
            },
            barcodeInfoFromStartup:{
                get(){
                    return this.$store.state.startUpData.startUpDataDetails;
                }
            },
        },
    }
</script>

<style scoped lang="scss">
     $table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

.secondary-dull-the-text{
    color: $secondary-text-color;
  }

.change-the-text-color{
    color: $dull-text-color;
    text-transform: uppercase;
    height: 22px;
    width: fit-content;
    border: 1px solid #F49D1A;
    border-radius: 10px;
    padding: 3px 9px;
    color: #F49D1A;
    font-size: 10px;
    letter-spacing: 0.5px;
  }

    .text-ellipsis{
        display: block;
    }

    .ingest-report-div{
        padding: 0px 30px 10px 30px;
        height: calc(100% - 115px);
        overflow: auto;
    }

    th, td{
        text-align: start;
    }

    tbody tr{
        border-bottom: $secondary-border-color;
    }

    .primary-btn-style{
        width: 100%;
        text-align: end;
        button{
            height: 38px;
            width: 70px;
            font-size:14px;
        }
        .text-light:hover{
        text-decoration: underline;
        }
    }
    .activeclass {
        color: $active-blue;
    }
    .ccomm-logs-row:hover {
        .jobs-info-icon{
            visibility:visible;
        }
    }

    .ccomm-logs-row:hover{
        color: $active-blue;
    }
    .table-with-border {
        thead {
            border-bottom: none;
        }
        tr {
            border-bottom: none;
        }
    }
    
    .table{
        color:#fff !important;
        th{
            border-top:none !important;
            padding: 1rem !important;
        }
        td{
            border-top:none !important;
            padding: 0px !important;
            padding-inline-start: 2px !important;
            padding-bottom: 10px !important;
        }
    }
    .table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th{
            position: sticky;
            top: 0;
            background:$primary-background;
            z-index:9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr{
            height:60px;
            }
        }
    }

    .search-bar-comm-style {
        height: 30px;
        position: relative;
        input {
            border: $border-color !important;
            position: absolute;
            top: 12%;
            inset-inline-start:5%;
            height: 38px !important;
            padding-inline-start: 8%;
        }
        svg {
            position: absolute;
            inset-inline-start:24px;
            top: 34%;
        }
    }

    .value-style {
        color: $text-color;
        width: 97%;
        text-align: start;
        padding-top: 3px;
        padding-bottom: 3px;
        padding-inline-end: 5px;
    }

    .filter-fields-in-logs div{
        display:inline-flex;
        div.comm-div{
            display:inline-flex;
            width:25%;
            // padding-top:7px;
            position: relative;
            // inset-inline-end :2%;
            label{
            color:$dull-text-color;
            position: relative;
            inset-inline-end: 5px;
            width:30%;
            text-align:end;
            top:2px;
            }
            select,input{
            width:70%;
            height:27px;
            border:$border-color !important;
            }
        }
    }

    li {
      width: 25%;
      display: inline-flex;
      // margin-bottom: 20px;
    }

    .config-label {
        width: 26% !important;
        text-align: end;
        color: #757575;
        word-break: break-word;
        position: relative !important;
        top: 9px !important;
    }
    
    .config-value {
        margin-inline-start: 4px;
        width: 75% !important;
        display:grid;
        svg{
            position: relative;
            top: 9px;
            margin-inline-start: 10px;
        }
    }


  .dull-the-text{
    color: $secondary-text-color;
  }

    ::v-deep {
         .page-item.disabled .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none;
  }
  .page-item.active .page-link {
    background-color: $secondary-background-color !important;
    // border: none !important;
    border: $border-color !important;
    color: $active-blue;
    z-index: 0 !important;
  }
  .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none !important;
    color: $text-color;
    padding: 5px !important;
  }
  .page-link:hover {
    background-color: $bg-color-on-hover !important;
  }
  .pagination {
    float: inline-end;
    margin-bottom: 0px !important;
    margin-inline-end: 8px;
  }
  .VuePagination__count {
    color: $secondary-text-color !important;
    margin-bottom: 0px !important;
    font-size: 12px;
    margin-inline-end: 7px;
    margin-top: 1px;
    float: inline-end;
    position: relative;
    margin-inline-start: 5px;
    top: 5px;
  }
  .VuePagination__pagination-item {
    font-size: 14px;
    width: 27px;
  }
  .VuePagination__pagination-item-prev-chunk {
    display: none;
  }
  .VuePagination__pagination-item-next-chunk {
    display: none;
  }

  .VuePagination__pagination-item-prev-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page a:before {
    width: 50px;
    content: "next ";
  }

  .VuePagination__pagination-item-prev-page a:after {
    width: 50px;
    content: " prev";
  }
  .v-list {
    padding: 0px !important;
  }
  .v-list-item {
    text-align: start;
    border: $secondary-border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title {
      font-size: 14px !important;
      color: $text-color !important;
    }
  }
  .v-menu__content {
    width: 190px !important;
  }
}    

.file-extra-info{
    font-size: 12px;
    color: $secondary-text-color;
    user-select: text !important; 
    cursor:text;
}

.validationmessage{
    color: $dull-text-color;
}
</style>